export default __webpack_public_path__ + "static/media/I10770.b4009b8a.jpg";